import {take, range, partial} from 'lodash'
import moment from 'moment'
import Fade from '@mui/material/Fade'
import React from 'react'
import Text from 'react-text'
import {Consumer} from '../../context'
import {deletePlan} from '../../context/post'
import Toolbar from './toolbar'
import Label from '../label'
import confirmDialog from '../confirm-dialog'
import './day.styl'
import { planLink } from 'planning/navigation'

function Plan (props) {

  const {id, subject: subjectId = 'C1', group, context} = props
  const subject = context.subjects.find(subject => subject.id == subjectId)

  const start = moment(props.start).format('YYYY-MM-DD')
  const finish = moment(props.finish).format('YYYY-MM-DD')
  const title = start == finish
    ? props.title
    : `${props.title}:  ${moment(props.start).format('MM/DD')} ${context.translate('to')} ${moment(props.finish).format('MM/DD')}`
  return (
    <div className="schedule-plan">
      {subject && (
        <div className="color-band-wrapper">
          <div className="color-band" style={{backgroundColor: subject.color}} />
        </div>
      )}
      <div className="content">
        <label title={title}>{title}</label>
      </div>
      <div className="actions-wrapper">
        <div className="actions">
          <div
            className="action preview"
            onClick={()=> {
              planLink(context, id, () => start, 'preview')
            }}
          >
            {context.translate('preview_title')}
          </div>
          <div
            className="action edit"
            onClick={() => {
              planLink(context, id, () => start)
            }}
          >
            <Text id="edit_label" />
          </div>
          <div
            className="action duplicate"
            onClick={() => {
              const {navigate, view} = context
              navigate({view, planId: id}, '/:languageId/:role/:page/:view/duplicate/:planId', {preserveQuery: true})
            }}
          >
              <Text id="duplicate" />
          </div>
          <div
            className="action delete"
            onClick={ () =>
              confirmDialog({
                className: 'delete-plan',
                translate: context.translate,
                children: (
                  <div className="message">
                    <div className="question">
                      {context.translate('confirm_delete_item')}
                    </div>
                    <div className="title">
                      {title}
                    </div>
                  </div>
                ),
                onConfirm: () => {
                  deletePlan(id).then(() => {
                    const planUpdates = props.context.planUpdates + 1
                    props.context.setState({planUpdates})
                  })
                }
              })
            }
          >
            <Text id="delete_label" />
          </div>
        </div>
      </div>
    </div>
  )
}

export default function DayView (props) {

  const {date} = props

  return (<Consumer>{ context => {
    const {groups, query, action} = context

    const plans = context.plans
      .map(plan => {
        return {...plan, context, date}
      })
      .map((props,i) => (<Plan key={i} {...props}/>))

    return (
      <div className="planning day view">
        <Toolbar {...props} />
        <div className="calendar">
          {/* <Fade in={context.plansUpdated}> */}
            <div className="schedule-plans">
              {plans}
            </div>
          {/* </Fade> */}
        </div>
      </div>
    )}}</Consumer>)
}
